module.exports = __webpack_public_path__ + "static/media/Aeroplane.16d006cd.png";